import { Navigate } from "react-router-dom";

const PARENT_TYPE_CONFIG = {
  normal_parent: ["normal_parent"],
  school_parent: ["school_parent"],
  mixed: ["normal_parent", "school_parent"],
};

const getDashboardPath = (type) => {
  switch (type) {
    case "normal_parent":
      return "/parent/dashboard";
    case "school_parent":
      return "/school-parent/dashboard";
    default:
      return "/parent/dashboard";
  }
};

const ParentDashboardGuard = ({ dashboard, children }) => {
  const userRaw = localStorage.getItem("user");
  if (!userRaw) return null;

  const parsed = JSON.parse(userRaw);
  const parentType = parsed?.user?.parent_type;
  if (!parentType) return null;

  const allowedDashboards = PARENT_TYPE_CONFIG[parentType] || [];

  // ❌ Only non-mixed users should be restricted
  if (parentType !== "mixed" && !allowedDashboards.includes(dashboard)) {
    return <Navigate to={getDashboardPath(parentType)} replace />;
  }

  // ✅ mixed users can access both
  return children;
};

export default ParentDashboardGuard;
